export default {
  // Page title
  'page.title': 'الساعة العالمية',

  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': 'الوقت المحلي',
  'timezone.currentTime': 'الوقت الحالي',
  'timezone.label': 'المنطقة الزمنية',
  'timezone.title': 'المنطقة الزمنية لـ {{city}}',
  'timezone.localClockOffset': 'فرق التوقيت المحلي',
  'timezone.timeZone': 'المنطقة الزمنية',
  'timezone.today': 'اليوم',
  'timezone.hours': 'س',
  'timezone.standardTimeZone': 'المنطقة الزمنية القياسية',
  'timezone.daylightSavingTimeZone': 'المنطقة الزمنية الصيفية',

  // City names (keeping English as standard)
  'city.newYork': 'نيويورك',
  'city.london': 'لندن',
  'city.paris': 'باريس',
  'city.tokyo': 'طوكيو',
  'city.sydney': 'سيدني',
  'city.dubai': 'دبي',
  'city.singapore': 'سنغافورة',
  'city.hongKong': 'هونغ كونغ',
  'city.shanghai': 'شنغهاي',
  'city.beijing': 'بكين',
  'city.mumbai': 'مومباي',
  'city.moscow': 'موسكو',
  'city.berlin': 'برلين',
  'city.losAngeles': 'لوس أنجلوس',
  'city.chicago': 'شيكاغو',
  'city.toronto': 'تورونتو',
  'city.vancouver': 'فانكوفر',
  'city.brasilia': 'برازيليا',
  'city.buenosAires': 'بوينس آيرس',
  'city.cairo': 'القاهرة',
  'city.istanbul': 'إسطنبول',

  // How to use
  'howto.title': 'كيفية استخدام الساعة العالمية عبر الإنترنت',
  'howto.step1': 'يعرض موقع الساعة العالمية هذا الوقت الحالي والوقت العالمي لأي مدينة في العالم. تحقق من المناطق الزمنية وفروقات الوقت العالمية والوقت الدولي فوراً في جميع أنحاء العالم.',
  'howto.step2': 'تعرض الصفحة الرئيسية للساعة العالمية وقتك المحلي بالإضافة إلى ساعات عالمية متعددة للمدن الرئيسية. تعرض كل منطقة زمنية عالمية معلومات دقيقة عن الوقت والتاريخ وفرق التوقيت.',
  'howto.step3': 'انقر على أي اسم مدينة في قائمة الساعة العالمية لعرض معلومات تفصيلية عن المنطقة الزمنية. توفر كل صفحة وقت عالمية بيانات شاملة عن المنطقة الزمنية والوقت الحالي لذلك الموقع.',
  'howto.step4': 'استخدم البحث في الساعة العالمية للعثور على الوقت في أي مدينة عالمية. مثالي للتحقق من المناطق الزمنية العالمية وتنسيق الوقت الدولي واحتياجات إدارة الوقت العالمية.',

  // User reviews
  'reviews.title': 'آراء المستخدمين',
  'reviews.globalBusiness': 'أساسي للأعمال التجارية الدولية! من السهل تنسيق أوقات الاجتماعات عبر مناطق زمنية مختلفة، عملي جداً.',
  'reviews.travelBlogger': 'ضروري لتخطيط السفر! أعرف دائماً الوقت المحلي في وجهتي، لا مزيد من الارتباك بسبب فرق التوقيت.',
  'reviews.remoteTeam': 'مثالي للتعاون مع الفريق عن بُعد! من السهل معرفة متى يعمل الزملاء في بلدان مختلفة.',
  'reviews.internationalFamily': 'رائع للبقاء على اتصال مع العائلة في الخارج! أعرف دائماً أفضل وقت للاتصال دون إزعاج نومهم.',
  'reviews.managerZhang': 'كمدير مشروع، يساعدني هذا في جدولة الاجتماعات مع العملاء العالميين بشكل أكثر فعالية.',

  // User names
  'user.globalBusiness': 'الأعمال العالمية',
  'user.travelBlogger': 'مدون السفر',
  'user.remoteTeam': 'مطور عن بُعد',
  'user.internationalFamily': 'عائلة دولية',
  'user.managerZhang': 'المدير تشانغ',

  // Keywords
  'keywords.worldclock': 'الساعة العالمية المناطق الزمنية الوقت الدولي كم الساعة',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': 'الوقت حسب البلد',
  'timeIn': 'الوقت في',
  'cities': 'مدن',
  'available': 'متاحة',
  'citiesIn': 'مدن في',
  'viewDetails': 'عرض التفاصيل',
  'countryNotFound': 'البلد غير موجود',
  'backToWorldClock': 'العودة إلى الساعة العالمية',
  'cityNotFound': 'المدينة غير موجودة',
  'popularCitiesIn': 'المدن الشهيرة في',
  'currentTime': 'الوقت الحالي',
};